import { render, staticRenderFns } from "./UsedValuePassTransaction.vue?vue&type=template&id=4efec784&"
import script from "./UsedValuePassTransaction.vue?vue&type=script&lang=js&"
export * from "./UsedValuePassTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports